import React from 'react';
import Panel from '../../../../../components/outline/Panel';
import RadioGroupWithInputForm from '../../../../../components/form/RadioGroupWithInputForm';
import {
  CANCEL_LIMIT_RADIO_LIST,
  CONSUMER_INJURY_RADIO_LIST,
  DELIVERY_DELAY_RADIO_LIST,
  EXCHANGE_REFUND_GUARANTEE_RADIO_LIST,
  REFUND_BY_SELLER_RADIO_LIST,
  TRADING_CONDITION_MAX_LENGTH,
} from '../../../../../constants/service/app/productRegisterConstants';
import './BrandDetailProductRegisterTradingCondition.scss';
import { formRequiredRules } from '../../../../../lib/formRules';

const BrandDetailProductRegisterTradingCondition = ({ data, isEditable, form }) => {
  const { refundBySeller, cancelLimit, exchangeRefundGuarantee, deliveryDelay, consumerInjury } = data;
  return (
    <Panel className="brand-detail-product-register-trading-condition">
      <div className="panel-header">
        <div className="title">거래조건에 관한 정보</div>
      </div>

      <div className="panel-body">
        {/*브랜드 책임으로 인한 반품의 경우 반품 가능 기간 및 통신판매업자가 부담하는 반품비용에 대한 정보*/}
        <RadioGroupWithInputForm
          label="브랜드 책임으로 인한 반품의 경우 반품 가능 기간 및 통신판매업자가 부담하는 반품비용에 대한 정보"
          form={form}
          maxLength={TRADING_CONDITION_MAX_LENGTH}
          list={REFUND_BY_SELLER_RADIO_LIST}
          rules={[formRequiredRules(true, '필수 값입니다.')]}
          direction="vertical"
          isEditable={isEditable}
          initialValue={refundBySeller}
          name="refundBySeller"
        />

        {/*반품 / 교환 불가사유*/}
        <RadioGroupWithInputForm
          label="반품 / 교환 불가사유"
          form={form}
          list={CANCEL_LIMIT_RADIO_LIST}
          maxLength={TRADING_CONDITION_MAX_LENGTH}
          rules={[formRequiredRules(true, '필수 값입니다.')]}
          direction="vertical"
          isEditable={isEditable}
          initialValue={cancelLimit}
          name="cancelLimit"
        />
        {/*재화등의 교환·반품·보증 조건 및 품질보증기준*/}
        <RadioGroupWithInputForm
          label="재화등의 교환·반품·보증 조건 및 품질보증기준"
          form={form}
          maxLength={TRADING_CONDITION_MAX_LENGTH}
          list={EXCHANGE_REFUND_GUARANTEE_RADIO_LIST}
          rules={[formRequiredRules(true, '필수 값입니다.')]}
          direction="vertical"
          isEditable={isEditable}
          initialValue={exchangeRefundGuarantee}
          name="exchangeRefundGuarantee"
        />

        {/*대금을 환불받기 위한 방법과 환불이 지연될 경우 지연에 따른 배상금을 지급받을 수 있다는 사실 및 배상금 지급의 구체적 조건 및 절차*/}
        <RadioGroupWithInputForm
          label="대금을 환불받기 위한 방법과 환불이 지연될 경우 지연에 따른 배상금을 지급받을 수 있다는 사실 및 배상금 지급의 구체적 조건 및 절차"
          form={form}
          maxLength={TRADING_CONDITION_MAX_LENGTH}
          list={DELIVERY_DELAY_RADIO_LIST}
          rules={[formRequiredRules(true, '필수 값입니다.')]}
          direction="vertical"
          isEditable={isEditable}
          initialValue={deliveryDelay}
          name="deliveryDelay"
        />

        {/*소비자피해보상의 처리, 재화등에 대한 불만 처리 및 소비자와 사업자 사이의 분쟁처리에 관한 사항*/}
        <RadioGroupWithInputForm
          label="소비자피해보상의 처리, 재화등에 대한 불만 처리 및 소비자와 사업자 사이의 분쟁처리에 관한 사항"
          form={form}
          maxLength={TRADING_CONDITION_MAX_LENGTH}
          list={CONSUMER_INJURY_RADIO_LIST}
          rules={[formRequiredRules(true, '필수 값입니다.')]}
          direction="vertical"
          isEditable={isEditable}
          initialValue={consumerInjury}
          name="consumerInjury"
        />
      </div>
    </Panel>
  );
};

export default BrandDetailProductRegisterTradingCondition;
